import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Flex, Heading, Image, Text, Button } from '@chakra-ui/react';


const borderBg = () => {
    return(
    <Box bgColor={'rgba(244, 246, 248)'} mt={6} h={'5px'}>
{/* <Text>tgvgrf</Text> */}
    </Box>
    )
}
export default borderBg;